import { Injectable } from '@angular/core';
import {
  BaseServiceErrorResolverService
} from '../../../../core/services/error-resolvers/base-service-error-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class SeminarsErrorResolverService extends BaseServiceErrorResolverService {
  codes = {
    'ArticleNotFound': 'Artikel mit angegebener Ordnungsnummer nicht gefunden',
    'SeminarArticleInvalidCategory': 'Seminarartikel Ungültige Kategorie',
    'SeminarEventNoFreeSeats': 'Seminar hat keine freien Plätze mehr'
  };
}
